// Vendor imports
const validator = require('validator')
// Client lib imports
const { FriendlyRequestError } = require('client/lib/request')
// Client V2 common imports
const confirmModalActions = require('client-v2/common/containers/confirm-modal/actions')
const toastsActions = require('client-v2/common/containers/toasts/actions')
const { ARTICLE_IS_MIXED_CHANGE_PENDING } = require('client-v2/common/models/article/actions')
const { userProfilePostModalHref } = require('client-v2/common/models/user/actions')
const tag = require('client-v2/common/utils/hyperscript')
// Sibling imports
const API = require('client-v2/common/containers/collection-select-modal/api')
const selectors = require('./selectors')

// Action types

const SHOW = 'CONTENT_ADD_MODAL_SHOW'
const HIDE = 'CONTENT_ADD_MODAL_HIDE'
const ARTICLE_FAILED = 'CONTENT_ADD_MODAL_ARTICLE_FAILED'
const ARTICLE_LOADED = 'CONTENT_ADD_MODAL_ARTICLE_LOADED'
const ARTICLE_LOADING = 'CONTENT_ADD_MODAL_ARTICLE_LOADING'
const SUBMIT_FAILED = 'CONTENT_ADD_MODAL_SUBMIT_FAILED'
const SUBMIT_LOADED = 'CONTENT_ADD_MODAL_SUBMIT_LOADED'
const SUBMIT_INVALID_URL = 'CONTENT_ADD_MODAL_SUBMIT_INVALID_URL'
const SUBMIT_LOADING = 'CONTENT_ADD_MODAL_SUBMIT_LOADING'
const SET_URL_TEXT = 'CONTENT_ADD_MODAL_SET_URL_TEXT'

// Action creators

function hide() {
  return {
    type: HIDE
  }
}

function setUrlText(url) {
  return {
    type: SET_URL_TEXT,
    payload: url
  }
}

function show(options = { url: '' }) {
  return {
    type: SHOW,
    payload: options
  }
}

// Action dispatchers

function fetchArticle() {
  return async function (dispatch, getState) {
    const url = selectors.url(getState())
    if (url) {
      if (!validator.isURL(url || '', {
        'require_valid_protocol': false,
        'allow_protocol_relative_urls': true
      })) {
        return dispatch({
          type: SUBMIT_INVALID_URL
        })
      }
      dispatch({
        type: ARTICLE_LOADING
      })
      try {
        dispatch({
          type: ARTICLE_LOADED,
          payload: await API.extractArticleFromUrl(url)
        })
      } catch (err) {
        dispatch({
          type: ARTICLE_FAILED,
          payload: url
        })
      }
    }
  }
}

function retryFetch() {
  return async function (dispatch) {
    dispatch({
      type: ARTICLE_LOADING
    })
    setTimeout(() => {
      dispatch(fetchArticle())
    }, 1000)
  }
}

function submit() {
  return async function (dispatch, getState) {
    const state = getState()
    if (selectors.isSubmitPending(state)) {
      return // Submission is already in-progress
    }
    dispatch({
      type: ARTICLE_IS_MIXED_CHANGE_PENDING
    })
    try {
      const { user } = state
      const urlId = selectors.urlId(state)
      dispatch({
        type: SUBMIT_LOADED,
        payload: await API.addToMixedCollection(urlId)
      })
      dispatch(showAddedToProfileToast(user, urlId))
    } catch (err) {
      dispatch({
        type: SUBMIT_FAILED
      })
      const message = err instanceof FriendlyRequestError
      ? err.message
      : 'Something went wrong. Please try again.'
      dispatch(confirmModalActions.alert({
        heading: 'Content submission failed',
        subheading: message
      }))
      throw err
    }
  }
}

// Exports

module.exports = {
  // Action types
  SHOW,
  HIDE,
  ARTICLE_FAILED,
  ARTICLE_LOADED,
  ARTICLE_LOADING,
  SUBMIT_FAILED,
  SUBMIT_INVALID_URL,
  SUBMIT_LOADED,
  SUBMIT_LOADING,
  SET_URL_TEXT,
  // Action creators
  hide,
  setUrlText,
  // Action dispatchers
  fetchArticle,
  retryFetch,
  show,
  submit
}

// Toast helpers

function showAddedToProfileToast(user, urlId) {
  return toastsActions.showNotice({
    message: () => tag([
      'Mixed to your profile! ',
      tag('a', {
        href: userProfilePostModalHref(user, urlId)
      },
      'View post'
      )
    ])
  })
}
